const styles = theme => ({
  bubble: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignSelf: 'stretch',
    padding: '12px',
    borderRadius: '10px',
    background: 'var(--mcg-bg, #F4F6F8)',
    fontFamily: 'Inter',
  },

  bubbleHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
  },

  bubbleTitle: {
    color: '#5B6576',
  },

  bubblePercent: {
    color: '#1B2433',
    fontWeight: 600,
    fontVariantNumeric: 'tabular-nums',
  },

  bubbleStage: {
    fontSize: '12px',
    color: '#5B6576',
  },

  track: {
    height: '4px',
    borderRadius: '2px',
    background: '#DDE1E7',
    overflow: 'hidden',
  },

  trackLarge: {
    height: '6px',
    borderRadius: '3px',
    marginTop: '6px',
  },

  fill: {
    height: '100%',
    background: '#1565F5',
    transition: 'width .6s ease-out',
  },

  panel: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'auto',
    borderRadius: '8px',
    background: '#F4F5F7',
    fontFamily: 'Inter',
    color: '#1B2433',
  },

  panelContent: {
    width: '420px',
    maxWidth: 'calc(100% - 32px)',
    display: 'flex',
    flexDirection: 'column',
    gap: '22px',
    padding: '24px 0',
  },

  summary: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },

  stepCount: {
    fontSize: '13px',
    color: '#5B6576',
  },

  summaryRow: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: '12px',
  },

  stageTitle: {
    fontSize: '20px',
    fontWeight: 600,
  },

  percentLarge: {
    fontSize: '28px',
    fontWeight: 700,
    fontVariantNumeric: 'tabular-nums',
  },

  stageList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },

  stageItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontSize: '14px',
    color: '#1B2433',
  },

  stageItemPending: {
    color: '#9AA2AF',
  },

  stageItemActive: {
    fontWeight: 600,
  },

  dot: {
    width: '20px',
    height: '20px',
    flexShrink: 0,
    boxSizing: 'border-box',
    borderRadius: '50%',
    border: '2px solid #D5D9E0',
    background: '#fff',
    color: '#fff',
    fontSize: '11px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  dotDone: {
    borderColor: '#1565F5',
    background: '#1565F5',
  },

  dotActive: {
    borderColor: '#1565F5',
    borderTopColor: 'transparent',
    animation: '$spin .9s linear infinite',
  },

  tip: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    padding: '12px 14px',
    borderRadius: '8px',
    border: '1px solid #E3E6EB',
    background: '#fff',
  },

  tipBadge: {
    flexShrink: 0,
    padding: '2px 6px',
    borderRadius: '4px',
    background: '#E8F0FE',
    color: '#1565F5',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '.04em',
  },

  tipText: {
    fontSize: '13px',
    lineHeight: 1.5,
    color: '#3A4456',
    '& a': {
      color: '#1565F5',
      fontWeight: 500,
      textDecoration: 'none',
    },
    '& a:hover': {
      color: '#0B4BD1',
    },
  },

  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
})

export default styles
